export const CHUNK_RELOAD = "chunk-reload";
